import React from "react";
import { Outlet } from "react-router-dom";
import TrialBanner from "@/components/billing/TrialBanner";
import { LatestDemoBanner } from "./LatestDemoBanner";

/**
 * AppLayout
 *
 * Layout wrapper for authenticated app pages (dashboard, jobs, candidates, settings).
 * No header - navigation and user profile are handled by the Sidebar component
 * that each page renders individually.
 */
export const AppLayout: React.FC = () => {
  return (
    <main className="technical-app-shell min-h-screen bg-background">
      <TrialBanner />
      <LatestDemoBanner />
      <Outlet />
    </main>
  );
};

export default AppLayout;
